import {SESSION_PROJECT_CHANGE} from "../../../../gd/bus/bus-event-type";
import ApiProject from "../../../../gd/api/project";
import ProjectSession from "../../../../model2/project/project-session";

export const changeProjectColor = (project: ProjectSession, color: number)=> {

    // update session and rerender menu
    project.color = color
    gd.bus.triggerEvent(SESSION_PROJECT_CHANGE, project.id)

    // close popover
    gd.layout.popovers.closeAll()

    // save changes... and prevent reRender on the current browser tab
    ApiProject.updateNew(project.id, {
        color: color
    },{processSessionResponse: false})
}
